export const calculateProfit = (row) => {
    if (!row || !row.entry || !row.usersCount) {
        return 0;
    }
    const entryPrizePool = row.entry * row.usersCount;
    const jackpotMin = row.jackpotLimit ? +row.jackpotLimit : 0;
    if (entryPrizePool <= jackpotMin) {
        return entryPrizePool - jackpotMin;
    }
    const entriesForJackpot = Math.floor(jackpotMin / (row?.entry || 1));
    const entriesAboveJackpot = Math.max(0, row.usersCount - entriesForJackpot);
    const jackpotAbovePrizePool = entriesAboveJackpot * (row.entry || 0);


    const commissionRate = row.commission / 100;
    const entryFeeAboveJackpot = Math.round(jackpotAbovePrizePool * (1 - commissionRate));

    const jackpot = entryFeeAboveJackpot + jackpotMin;
    return entryPrizePool - jackpot;
};
